import React from 'react';
import bannerImage from '../../../assets/images/theme_2.svg';
import useUserLoginPage from './UseUserLoginPage';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import LoginPageHelmet from '../../HelmetComponents/LoginPageHelmet';

const UserLoginPage: React.FC = () => {
  // useDocumentTitle('Namasteji Manikchand - Login');
  const { formData, errors, buttonLoading, handleChange, handleSubmit } = useUserLoginPage();

  return (
    <>
      <LoginPageHelmet />
      <div className='flex items-center justify-center bg-gray-100 px-6  py-12 sm:py-12 md:py-16 lg:py-16'>
        <div className='bg-white w-full max-w-xl rounded-xl shadow-lg overflow-hidden min-h-96 pb-6 sm:pb-6 md:pb-8 lg:pb-10'>
          {/* Top Banner */}
          <img src={bannerImage} alt='Manikchand Banner' className='w-full h-full object-cover' />

          {/* Form Section */}
          <div className='p-2 py-2 sm:p-2 sm:py-2 md:p-14 md:py-6 lg:p-16 lg:py-6'>
            <h1
              className='text-center text-xl sm:text-xl md:text-2xl lg:text-3xl p-6 sm:p-6 md:p-6 lg:p-10 font-rubik 
                        text-[#552B18] sm:text-[#552B18] md:text-[#552B18] lg:text-black'
            >
              Sign In
            </h1>

            <div className='px-2 sm:px-2 md:px-4 lg:px-6 pt-4'>
              <form onSubmit={handleSubmit}>
                <div className='mb-4 font-poppins'>
                  <div
                    className={`flex border ${errors.mobile ? 'border-red-500' : 'border-gray-300'} rounded-xl overflow-hidden text-sm sm:text-sm md:text-lg lg:text-lg`}
                  >
                    <span className='bg-gray-100 text-gray-700 px-2 py-2 sm:px-2 sm:py-2 md:px-2 md:py-3 lg:px-3 lg:py-4 border-r border-gray-300'>
                      +91
                    </span>
                    <input
                      type='text'
                      name='mobile'
                      maxLength={10}
                      placeholder='Enter mobile number'
                      value={formData.mobile}
                      onChange={handleChange}
                      className='flex-1 px-2 py-2 sm:px-2 sm:py-2 md:px-2 md:py-3 lg:px-3 lg:py-4 outline-none'
                    />
                  </div>

                  {/* Error message shown below the input group */}
                  {errors.mobile && <p className='text-red-500 text-sm mt-1'>{errors.mobile}</p>}
                </div>

                <button
                  type='submit'
                  disabled={buttonLoading}
                  className='w-full bg-[#C12E2A] hover:bg-red-700 text-white py-2 sm:py-2 md:py-4 lg:py-4 rounded-xl text-sm sm:text-sm md:text-lg lg:text-lg font-medium font-poppins transition duration-200'
                >
                  {buttonLoading ? 'Processing...' : 'Continue'}
                </button>
              </form>
            </div>
            <p className='text-center text-xs sm:text-xs md:text-sm lg:text-sm text-black font-poppins mt-4'>
              Don`t have an account yet?{' '}
              <a href='/sign-up' className='text-blue-600 underline'>
                Sign Up
              </a>
            </p>
            <p
              className='text-center text-xs sm:text-xs md:text-sm lg:text-sm text-black 
                        mt-8 sm:mt-8 md:mt:14 lg:mt-14
                        pt-4 sm:pt-4 md:pt-6 lg:pt-10 
                        mb-4 sm:mb-4 md:mb-2 lg:mb-2 font-poppins'
            >
              By continuing, you agree to our <br />
              <a href='/terms-conditions' className='text-blue-600 underline'>
                Terms & Conditions
              </a>{' '}
              and{' '}
              <a href='/privacy-policy' className='text-blue-600 underline'>
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLoginPage;
